import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { CreateInvitation } from "@/entities/invitation/ui/create-invitation"
import { InvitationsTable } from "@/entities/invitation/ui/invitations-table"
import { fetchUsersInvitations, selectUsersInvitations, selectUsersInvitationsFirstLoad, selectUsersInvitationsLoading } from "@/entities/invitation"

export const UsersInvitationsPage = () => {
    const invitationsFirstLoad = useAppSelector(selectUsersInvitationsFirstLoad)
    const dispatch = useAppDispatch()
    const invitations = useAppSelector(selectUsersInvitations)
    const isLoading = useAppSelector(selectUsersInvitationsLoading)

    useEffect(() => {
        if (invitationsFirstLoad) {
            dispatch(fetchUsersInvitations())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Пользователи" />
            <div className="flexbox">
                <PageSubtitle title="Приглашения" />
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateInvitation onCreate={() => dispatch(fetchUsersInvitations())} role="users"/>
                </div>
                <InvitationsTable isLoading={isLoading} invitations={invitations} onDelete={() => dispatch(fetchUsersInvitations())} />
            </div>
        </div>
    )
}
